const baseApiUrl = 'https://seedmaster.codelabx.work';

const apiPath = '/api/v1';

const apiUrl = `${baseApiUrl}${apiPath}`;

const KeycloakUrl = 'https://keycloak.codelabx.work';

export const environment = {
  production: false,
  version: '0.0.1',
  buildDate: new Date().toISOString(),
  buildHash: 'local',
  apiUrl,
  KeycloakUrl,
  name: 'Development Environment (environment.dev.ts)',
  appName: 'seedexpert',
  appDescription:
    'A web application for managing delintages, productions, transfers, and reports.',
  appAuthor: 'Daly',
  appLicense: 'MIT',

  delintageAPI: `${apiUrl}/delintages`,
  productionAPI: `${apiUrl}/productions`,
  transferAPI: `${apiUrl}/transfers`,
  reportAPI: `${apiUrl}/reports`,
  siteAPI: `${apiUrl}/sites`,
  varietyAPI: `${apiUrl}/varieties`,
  waveAPI: `${apiUrl}/waves`,
  reportMetricAPI: `${apiUrl}/reports/metrics`,
};
